var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76747 2C3.36813 2 3.12993 2.44506 3.35144 2.77734L9.6195 12.1801C9.74522 12.3687 9.72835 12.6183 9.57839 12.7883L3.06625 20.1692C2.7814 20.4921 3.01063 21 3.44118 21L4.39957 21C4.53888 21 4.67187 20.9419 4.7665 20.8397L10.9727 14.135C11.1849 13.9058 11.5529 13.9251 11.74 14.1752L16.6941 20.7995C16.7885 20.9257 16.9369 21 17.0945 21H21.7614C22.1731 21 22.4084 20.5302 22.1618 20.2005L14.9038 10.4965C14.7583 10.302 14.7737 10.0312 14.9401 9.85433L21.54 2.8427C21.8404 2.52362 21.6141 2 21.176 2H20.0403C19.9077 2 19.7806 2.05267 19.6868 2.14643L13.7564 8.07638C13.5358 8.29695 13.1693 8.26389 12.9917 8.00739L8.98237 2.21542C8.88898 2.08051 8.73534 2 8.57126 2H3.76747ZM6.44982 4.80422C6.19764 4.47529 6.43216 4 6.84662 4H8.08654C8.24206 4 8.38873 4.07237 8.48335 4.19579L19.2162 18.1958C19.4684 18.5247 19.2338 19 18.8194 19H17.58C17.4244 19 17.2778 18.9276 17.1832 18.8042L6.44982 4.80422Z",
    fill: "#115099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5113d32f.svg";
export { ForwardRef as ReactComponent };